import React from 'react';
import { useTranslation } from 'react-i18next';
import { BringzzIcon, BringzzText, BringzzImage } from "@bringzz/components";
import AvatarExample from 'assets/images/AvatarExample.png';
import { ShimmerCard, ShimmerAvatar, ShimmerText } from './Shimmer';

const LoadingTeamMember = () => (
  <div className="flex items-center p-3 border rounded-lg bg-white">
    <ShimmerAvatar size="h-12 w-12" />
    <div className="ml-4 flex-1">
      <ShimmerText width="w-1/3" className="mb-2" />
      <ShimmerText width="w-1/2" />
    </div>
  </div>
);

const TeamTab = ({ loading, error, owner, activeTeamMembers }) => {
  const { t } = useTranslation('pharmacyProfile');
  if (loading) {
    return (
      <div className="p-4">
        <div className="mb-6">
          <ShimmerText width="w-1/3" height="h-6" className="mb-4" />
          <div className="flex items-center mb-4 p-3 bg-gray-50 rounded-lg">
            <ShimmerAvatar size="h-16 w-16" />
            <div className="ml-4 flex-1">
              <ShimmerText width="w-1/2" className="mb-2" />
              <ShimmerText width="w-1/3" />
            </div>
          </div>
        </div>

        <div>
          <ShimmerText width="w-1/3" height="h-6" className="mb-4" />
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[1, 2, 3, 4].map((item) => (
              <LoadingTeamMember key={item} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-center text-red-500">
        <BringzzText tag="p">{t('tabs.team.failed_to_load')}</BringzzText>
      </div>
    );
  }

  return (
    <div className="p-4 pb-24 md:pb-4">
      <div className="mb-6">
        <BringzzText tag="h3" className="font-bold text-lg mb-2">
          {t('tabs.team.pharmacy_owner')}
        </BringzzText>
        {owner && (
          <div className="flex items-center mb-4 p-3 bg-gray-50 rounded-lg">
            <BringzzImage 
              className="w-16 h-16 rounded-full mr-4 border-2 border-white"
              src={owner?.userPic || AvatarExample} 
              alt="Owner" 
            />
            <div>
              <BringzzText tag="p" className="font-semibold">
                {owner?.title} {owner?.firstName} {owner?.lastName}
              </BringzzText>
              {owner?.languageSkills && (
                <BringzzText tag="p" className="text-sm text-gray-600">
                  {owner.languageSkills}
                </BringzzText>
              )}
            </div>
          </div>
        )}
      </div>

      {activeTeamMembers && activeTeamMembers.length > 0 && (
        <div>
          <BringzzText tag="h3" className="font-bold text-lg mb-2">
            {t('tabs.team.staff_members')}
          </BringzzText>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {activeTeamMembers.map(member => (
              <div 
                key={member?.id} 
                className="flex items-center p-3 border rounded-lg bg-white hover:bg-gray-50 transition-colors"
              >
                <BringzzImage 
                  className="w-12 h-12 rounded-full mr-4 border-2 border-white"
                  src={member?.team_details?.userPic || AvatarExample} 
                  alt={`Staff member ${member?.userId_Dyn_Sort}`} 
                />
                <div>
                  <BringzzText tag="p" className="font-semibold">
                    {member?.userId_Dyn_Sort}
                  </BringzzText>
                  {member?.bio && (
                    <BringzzText tag="p" className="text-sm text-gray-600">
                      {member.bio}
                    </BringzzText>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamTab; 